<template>
  <v-container fluid style="height: 100%">
    <simple-history :histories="histories" :functionCategory="functionCategory"></simple-history>
  </v-container>
</template>

<script>
import SimpleHistory from "../common/SimpleHistory.vue";
import { statuses as ApiStatus } from "../../libs/api-client";
export default {
  name: "SupplierHistory",
  props: ["supplierCode"],
  components: {
    SimpleHistory,
  },
  data() {
    return {
      histories: {},
      functionCategory: "",
    };
  },
  mounted: async function () {
    this.onSearchHistory();
  },
  watch: {
    supplierCode() {
      this.onSearchHistory();
    },
  },
  methods: {
    onSearchHistory: async function () {
      try {
        if (!this.supplierCode) {
          this.histories = [];
          return;
        }
        this.$store.commit("ui/loading", true);
        this.functionCategory = "supplier";
        const response = await this.$store.dispatch("supplier/history", this.supplierCode);
        if (ApiStatus.isSystemError(response.data?.header)) {
          return this.redirectError();
        }
        console.log(response.data.contents);
        this.histories = response.data.contents.histories;
        this.$store.commit("ui/loading", false);
      } catch (error) {
        console.error("error:", this.$options._componentTag);
      } finally {
        this.loadingOff();
      }
    },
  },
};
</script>
